import { CssClassHelper } from "@cervval.js/client-html5-core/src/tools/cssClassHelper";
import { IconFA6 } from "./tools/fontAwesome6IconList.tools";
import { IconFA7 } from "./tools/fontAwesome7IconList.tools";

/**
 * Size of icon
 * @see https://fontawesome.com/docs/web/style/size
 */
export enum IconFaSize {
    // Relative sizing
    XS2 = "fa-2xs",
    XS = "fa-xs",
    SM = "fa-sm",
    LG = "fa-lg",
    XL = "fa-xl",
    XL2 = "fa-2xl",
    // Literal sizing
    X1 = "fa-1x",
    X2 = "fa-2x",
    X3 = "fa-3x",
    X4 = "fa-4x",
    X5 = "fa-5x",
    X6 = "fa-6x",
    X7 = "fa-7x",
    X8 = "fa-8x",
    X9 = "fa-9x",
    X10 = "fa-10x"
}

/** 
 * Rotation of icon
 * @see https://fontawesome.com/v5.15/how-to-use/on-the-web/styling/rotating-icons
 */
export enum IconFaRotate {
    ROTATE_90 = "fa-rotate-90",
    ROTATE_180 = "fa-rotate-180",
    ROTATE_270 = "fa-rotate-270",
    FLIP_HORIZONTAL = "fa-flip-horizontal",
    FLIP_VERTICAL = "fa-flip-vertical",
    FLIP_BOTH = "fa-flip-both"
}

/** 
 * Animation of icon
 * @see https://fontawesome.com/v5.15/how-to-use/on-the-web/styling/rotating-icons
 */
export enum IconFaAnimation {
    SPIN = "fa-spin",
    ROTATE = "fa-pulse"
}

/** 
 * Fontawesome class for icons, apply fixed with on icon 
 * @deprecated as it is the default behavior in Font Awesome 7 @see https://docs.fontawesome.com/upgrade/whats-changed
 */
export const FA_FW = "fa-fw";

/** Fontawesome class for icons, apply auto width on icon */
export const FA_WIDTH_AUTO = "fa-width-auto";

/** Refresh icon size, based on options.size */
export function refreshIconFaSize(cssClassHelper: CssClassHelper, size?: IconFaSize): void {
    if (size) {
        // Add to dynamic classlist 
        cssClassHelper.add(...size.split(" "));
    }
}

/** Refresh icon fixedWidth, based on options.size */
export function refreshIconFaFixedWidth(cssClassHelper: CssClassHelper, fixedWidth?: boolean): void {
    if (!fixedWidth) {
        // Add to dynamic classlist 
        cssClassHelper.add(FA_WIDTH_AUTO);
    }
}

/** Refresh icon inverse style, based on options.inverse */
export function refreshIconFaInverse(cssClassHelper: CssClassHelper, inverse?: boolean): void {
    if (inverse) {
        // Add to dynamic classlist 
        cssClassHelper.add("fa-inverse");
    }
}


/** Refresh icon animation, based on options.animation */
export function refreshIconFaAnimation(cssClassHelper: CssClassHelper, animation?: IconFaAnimation): void {
    if (animation) {
        cssClassHelper.add(animation);
    }
}


/** Refresh icon rotation, based on options.rotate */
export function refreshIconFaRotate(cssClassHelper: CssClassHelper, rotate?: IconFaRotate): void {
    if (rotate) {
        cssClassHelper.add(rotate);
    }
}


/** Refresh display of icon */
export function refreshIconFaDisplay(cssClassHelper: CssClassHelper, cssClasses?: string[]): void {

    // Clean added css classes
    cssClassHelper.clear();

    // Add custom classes
    cssClassHelper.add(...cssClasses ?? []);
}

/**
 * @returns full icon name for given icon name
 * ex:
 * getIconFaName(IconFA6.AIR_CONDITIONER) => fa-air-conditioner
 */
export function getIconFaName(iconName: IconFA6 | IconFA7): string {
    return "fa-" + iconName;
}